import 'select2/dist/js/select2.full.js';
import $ from 'jquery';
import moduleBackgroundImage from '@core/components/module-background-image/module-background-image';
import BaseModule from '@core/modules/base-module/base-module';

const customForm=new BaseModule();
customForm.name='custom-form';
customForm.init(that=> {
  moduleBackgroundImage(that.elements);

  $('.form-select').select2({
    minimumResultsForSearch: -1,
    containerCssClass: 'js-form-type-select',
    width: 'resolve'
  });

});
